import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const formatDate = (dateStr: string) => {
  if (!dateStr) return new Date().toLocaleDateString("en-GB");
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

// Date formatter for receipts

const SUPPORTED_FORMATS = [
  "MM/DD/YYYY HH:mm:ss",
  "MM/DD/YYYY hh:mm:ss",
  "MMM DD YYYY h:mmA",
  "MMM DD YYYY hh:mmA",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss",
  "DD-MM-YYYY HH:mm:ss",
  "YYYY-MM-DDTHH:mm:ssZ",
];

// Main formatter
export const formatReceiptDate = (
  date: string,
  outputFormat = "MM/DD/YYYY hh:mm:ss A",
) => {
  if (!date) return "—";

  // Try parsing with known formats
  for (let format of SUPPORTED_FORMATS) {
    const parsed = dayjs(date, format, true);
    if (parsed.isValid()) {
      return parsed.format(outputFormat);
    }
  }

  // Try default parsing (fallback)
  const fallback = dayjs(date);
  if (fallback.isValid()) {
    return fallback.format(outputFormat);
  }

  return date;
};
